import { render, staticRenderFns } from "./grabSingle.vue?vue&type=template&id=9ac327ac&"
import script from "./grabSingle.vue?vue&type=script&lang=js&"
export * from "./grabSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports